import _get from 'lodash/get';
import _replace from 'lodash/replace';
/**
 * cart contact factory
 * @param {Object} data
 * @param {string} defaultDialCode
 * @returns {Object}
 */
export function cartContactFactory(data, defaultDialCode) {
  if (data === void 0) {
    data = {};
  }
  if (defaultDialCode === void 0) {
    defaultDialCode = '';
  }
  var dialCode = _get(data, 'dialCode', defaultDialCode);
  return {
    title: _get(data, 'title', ''),
    firstName: _get(data, 'firstName', ''),
    lastName: _get(data, 'lastName', ''),
    email: _get(data, 'email', ''),
    phone: _replace(_get(data, 'phone', ''), dialCode, ''),
    dialCode: dialCode
  };
}